/**
 *  @desc 生成UUID 参考：https://blog.csdn.net/weixin_42333548/article/details/128981316
 */
export const generateUUID = () => {
  try {
    let d = new Date().getTime() // D 是随机种子

    if (window.performance && typeof window.performance.now === 'function') {
      d += performance.now()
    }

    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
    })

    return uuid
  } catch (error) {
    return '-999'
  }
}
